export default {
	ACCEPT_FROM_EMAIL: 'Accept from email',
	ACCEPT_NURSE_APPLIED_SHIFT: 'Accept nurse for shift',
	ACTIVATE_RECOMMENDED_SHIFTS: 'Activate recommended shifts',
	ACTIVE_NURSE: 'Set nurse active',
	ADD_BONUS_CANCEL_BUTTON: 'Add Bonus Cancel Button',
	ADD_BONUS_CONFIRM_BUTTON: 'Add Bonus Confirm Button',
	ADD_BONUS_EDIT_BUTTON: 'Add Bonus Edit Button',
	ADD_BONUS_FORM: 'Add Bonus Form',
	ADD_BONUS_NEXT_BUTTON: 'Add Bonus Next Button',
	ADD_BREAK_TIME: 'Add break time',
	ADD_COMMENT: 'Add comment',
	ADD_DNR_FOR_NURSE: 'Add dnr for nurse',
	ADD_DOCUMENT: 'Add document',
	ADD_NEW_ALERT: 'Add new alert',
	ADD_NEW_DNR: 'Add new dnr',
	ADD_NEW_JOB_HISTORY: 'Add new job history',
	ADD_NEW_LOCATION: 'Add new location',
	ADD_NEW_ORGANIZATION: 'Add new organization',
	ADD_NEW_SHIFT: 'Add new shift',
	ADD_NEW_USER: 'Add new user',
	ADD_REQUIREMENT: 'Add requirement',
	ADD_SHIFT_LEVEL_BONUS: 'Add Shift Level Bonus',
	ADD_SUPERVISOR_AVAILABILITY: 'Add Supervisor Availability',
	ADMIN_APPLY_SHIFT_HISTORY_FILTER: 'Admin Apply Shift History Filter',
	ADMIN_OPEN_SHIFT_HISTORY_FILTER: 'Admin Open Shift History Filter',
	ANNOUNCEMENTS_ADD_FORM: 'Announcements Add Form',
	ANNOUNCEMENTS_CANCEL_BUTTON: 'Announcements Cancel Button',
	ANNOUNCEMENTS_CREATE_BUTTON: 'Announcements Create Button',
	ANNOUNCEMENTS_DELETE_BUTTON: 'Announcements Delete Button',
	ANNOUNCEMENTS_EDIT_BUTTON: 'Announcements Edit Button',
	APPLY_BONUS_FILETR: 'Apply Bonus Filter',
	APPLY_SHIFT_DASHBOARD: 'Apply dashboard shift',
	APPLY_SHIFT_DETAIL: 'Apply shift detail shift ',
	APPLY_SHIFT_FILTER: 'Apply shift filter',
	APPLY_SHIFT_RECOMMENDATION: 'Apply recommendation shift from Recommended shifts tile',
	APPLY_SHIFT_RECOMMENDATION_FROM_Detail: 'Apply recommendation shift from shift detail page',
	APPLY_SHIFT_RECOMMENDATION_FROM_LIST: 'Apply recommendation shift from Open shift list',
	APPLY_TIMESHEET_FILTER: 'Apply timesheet filter',
	APPLY_USER_FILTER: 'Apply user filter',
	APPROVE_NURSE: 'Approve nurse',
	APPROVE_NURSE_REQUIREMENT_DOCS: 'Approve nurse requirement docs',
	APPROVE_TIMESHEET: 'Approve timesheet',
	ASSIGN_SHIFT_INITIATE: 'Assign shift initiate',
	ASSIGN_SHIFT_SET_FILTER: 'Assign shift set filter',
	ASSIGN_SHIFT_TO_NURSE: 'Assign shift to nurse',
	BOOKMARK_DELETED: 'Bookmark deleted',
	BOOKMARK_SAVED: 'Bookmark saved',
	CALENDAR_BACK: 'Calendar back',
	CALLOUT_EXCUSED_SET_FALSE: 'Admin Excused Called Out Set to FALSE',
	CALLOUT_EXCUSED_SET_TRUE: 'Admin Excused Called Out Set to True',
	CANCEL_ADD_NEW_DNR: 'Cancel add new dnr',
	CANCEL_CREATE_ORGANIZATION: 'Cancel create organization',
	CANCEL_NEW_REQUIREMENT_FORM: 'Cancel new requirement form',
	CANCEL_REQUIRED_DOCS: 'Cancel required docs',
	CANCEL_SAVE_FACILITY_DETAILS_INFO: 'Cancel save facility details info',
	CANCEL_SHIFT: 'Cancel shift',
	CHANGE_PAGENUM_ORGANIZATION: 'Change pagenum organization',
	CHANGE_PAGENUM_REQUESTS: 'Change pagenum requests',
	CHANGE_PAGENUM_SHIFTS: 'Change pagenum shifts',
	CHANGE_PAGENUM_TIMESHEETS: 'Change pagenum timesheets',
	CHANGE_PAGENUM_USERS: 'Change pagenum users',
	CHECKIN_COMPLETED: 'Checkin completed',
	CHECKOUT_COMPLETED: 'Checkout completed',
	CHECKOUT_PAGE_VIEWED: 'Checkout page viewed',
	CLICK_REQUIRED_DOCS: 'Click required docs',
	CLOSE_NOTIFICATION_BAR: 'Close notification bar',
	CLOSE_NPS_SURVEY: 'Close nps survey',
	CLOSE_QUICK_ACTIONS_PANEL: 'Close quick actions panel',
	CONFIRM_ORGANIZATION_INACTIVATION: 'Confirm organization inactivation',
	CONTACT_INFO_CLOSE: 'Contact info close',
	CONTACT_INFO_SAVE: 'Contact info save',
	CONTACT_INFO_SKIP: 'Contact info skip',
	CREATE_AND_ASSIGN_SHIFT_INITIATE: 'Create and assign shift initiate',
	CREATE_AND_ASSIGN_SHIFT_TO_NURSE: 'Create and assign shift to nurse',
	DELETE_BREAK_TIME: 'Delete break time',
	DELETE_DNR: 'Delete dnr',
	DELETE_JOB_HISTORY: 'Delete job history',
	DELETE_REQUIRED_DOCS: 'Delete required docs',
	DELETE_RESUME: 'Delete resume',
	DISMISS_NURSE_RATING: 'Dismiss nurse rating',
	DISMISS_ORGANIZATION_RATING: 'Dismiss organization rating',
	DOCUMENTS_CLOSE: 'Documents close',
	DOCUMENTS_NAVIGATE_BACK: 'Documents navigate back',
	DOCUMENTS_SAVE: 'Documents save',
	DOCUMENTS_SKIP: 'Documents skip',
	DOWNLOAD_BONUSES: 'Download Bonuses',
	DOWNLOAD_ORGANIZATIONS_LIST: 'Download organizations list',
	DOWNLOAD_PROFILE: 'Download profile',
	DOWNLOAD_SHIFTS: 'Download shifts',
	DOWNLOAD_TIMESHEETS: 'Download timesheets',
	EDIT_BONUS_CANCEL_BUTTON: 'Edit Bonus Cancel Button',
	EDIT_BONUS_CONFIRM_BUTTON: 'Edit Bonus Confirm Button',
	EDIT_BONUS_EDIT_BUTTON: 'Edit Bonus Edit Button',
	EDIT_BONUS_FORM: 'Edit Bonus Form',
	EDIT_BONUS_NEXT_BUTTON: 'Edit Bonus Next Button',
	EDIT_BREAK_TIME: 'Edit break time',
	EDIT_JOB_HOSTORY: 'Edit job history',
	EDIT_LOCATION: 'Edit location',
	EDIT_ORGANIZATION: 'Edit organization',
	EDIT_ORGANIZATION_DETAILS: 'Edit organization details',
	EDIT_SHIFT_LEVEL_BONUS: 'Edit Shift Level Bonus',
	EDIT_SUPERVISOR_AVAILABILITY: 'Edit Supervisor Availability',
	EDIT_SUSPEND_NURSE: 'Edit Suspended nurse time',
	FIRSTPAGE_REQUESTS: 'Firstpage requests',
	FIRSTPAGE_SHIFTS: 'Firstpage shifts',
	HAZARD_PAY_USER_TOGGLE_SET_FALSE: 'Nurse Hazard Pay Toggle Set to FALSE',
	HAZARD_PAY_USER_TOGGLE_SET_TRUE: 'Nurse Hazard Pay Toggle Set to TRUE',
	INACTIVE_NURSE: 'Set nurse inactive',
	INITIATE_ADD_DOCUMENT: 'Initiate add document',
	INITIATE_UPDATE_TIMESHEET: 'Initiate update timesheet status',
	JOB_HISTORY_ADD_ADDITIONAL_JOB: 'Job history add additional job',
	JOB_HISTORY_CLOSE: 'Job history close',
	JOB_HISTORY_NAVIGATE_BACK: 'Job history navigate back',
	JOB_HISTORY_RESUME_UPLOAD: 'Job history resume upload',
	JOB_HISTORY_SAVE: 'Job history save',
	JOB_HISTORY_SKIP: 'Job history skip',
	LASTPAGE_REQUESTS: 'Last page requests',
	LASTPAGE_SHIFTS: 'Last_page shifts',
	LINK_TO_STORE: 'Link to store',
	LIST_ALL_TIMESHEETS: 'List all timesheets',
	LIST_ANNOUNCEMENTS: 'List Announcement',
	LIST_APPROVED_TIMESHEETS: 'List approved timesheets',
	LIST_CLOSED_REQUESTS: 'List closed requests',
	LIST_CRITICAL_ALERTS: 'List critical alerts',
	LIST_DNR: 'List dnr',
	LIST_GENERAL_ALERTS: 'List general alerts',
	LIST_INELIGIBLE_TIMESHEETS: 'List ineligible timesheets',
	LIST_INMEDIATION_TIMESHEETS: 'List inmediation timesheets',
	LIST_NURSE_REQUESTS: 'List nurse requests',
	LIST_OPEN_SHIFTS: 'List open shifts',
	LIST_ORGANIZATIONS: 'List organizations',
	LIST_PAID_TIMESHEETS: 'List paid timesheets',
	LIST_PENDING_REQUESTS: 'List pending requests',
	LIST_PENDING_TIMESHEETS: 'List pending timesheets',
	LIST_REQUIREMENTS: 'List requirements',
	LIST_SHIFTS: 'List shifts',
	LIST_TIMESHEETS: 'List timesheets',
	LIST_USERS: 'List users',
	MARK_ALL_AS_PAID_BONUS_CANCEL_BUTTON: 'Mark All As Paid Bonus Cancel Button',
	MARK_ALL_AS_PAID_BONUS_CONFIRM_BUTTON: 'Mark All As Paid Bonus Confirm Button',
	MARK_ALL_AS_PAID_BONUS_EDIT_BUTTON: 'Mark All As Paid Bonus Edit Button',
	MARK_ALL_AS_PAID_BONUS_NEXT_BUTTON: 'Mark All As Paid Bonus Next Button',
	MARK_ALL_TIMESHEETS_AS_PAID: 'Mark all timesheets as paid',
	MARK_TIMESHEET_AS_PAID: 'Mark timesheet as paid',
	NAVIGATE_BACK_SHIFT_DETAIL: 'Navigate back shift detail',
	NEW_ONBOARDING: 'OB2_Twosteps',
	NEW_RESET: 'RP2_Token',
	NEXTPAGE_REQUESTS: 'Nextpage requests',
	NEXTPAGE_SHIFTS: 'Nextpage shifts',
	NO_CONFIRMATION_PAGE: 'No confirmation page',
	NURSE_DETAIL_CLICK: 'Nurse detail click',
	NURSE_REMEDIATION: 'Nurse remediation',
	NURSE_SHIFT_ACCEPTED: 'Nurse shift accepted',
	NURSE_SHIFT_REJECTED: 'Nurse shift declined',
	NURSE_SHIFT_REQUEST: 'Nurse shift request',
	NURSE_SHIFT_UNDO_REJECT: 'Nurse shift undo decline',
	OLD_ONBOARDING: 'OB1_Foursteps',
	OLD_RESET: 'RP1_TempPassword',
	ONBOARDING_INITIATE: 'Onboarding initiate',
	OPEN_FEEDBACK_FORM: 'Open feedback form',
	OPEN_QUICK_ACTIONS_PANEL: 'Open quick actions panel',
	ORGANIZATION_DETAIL_NAVIGATE_BACK: 'Organization detail navigate back',
	PAGE_LOADED: 'Page loaded',
	POSTED_SHIFT: 'Posted shift',
	PREVPAGE_REQUESTS: 'Prevpage requests',
	PREVPAGE_SHIFTS: 'Prevpage shifts',
	RAN_PAGE_DASHBOARD: 'Request Clinician Click',
	RAN_PAGE_DASHBOARD_DISABLE_TOOLTIP: 'Request Clinician Disabled Tooltip',
	REJECT_FROM_EMAIL: 'Decline from email',
	REJECT_NURSE: 'Reject nurse',
	REJECT_NURSE_APPLIED_SHIFT: 'Decline nurse for shift',
	REJECT_NURSE_REQUIREMENT_DOCS: 'Reject nurse requirement docs',
	REMOVE_DOCUMENT: 'Remove document',
	REMOVE_NOTIFICATION: 'Remove notification',
	REQUEST_NURSE_APPLIED_SHIFT: 'Request nurse for shift',
	REQUEST_RESET_PASSWORD_LINK: 'Request reset password link',
	RESET_PASSWORD: 'Reset password',
	ROLES_AND_SPECIALITY_CLOSE: 'Roles and speciality close',
	ROLES_AND_SPECIALITY_NAVIGATE_BACK: 'Roles and speciality navigate back',
	ROLES_AND_SPECIALITY_SAVE: 'Roles and speciality save',
	SAVE_FACILITY_DETAILS_INFO: 'Save facility details info',
	SAVE_NEW_REQUIREMENT: 'Save new requirement',
	SCHEDULE_NURSE_REQUIREMENT_DOCS: 'Schedule nurse requirement docs',
	SEARCH_DNR: 'Search dnr',
	SEARCH_NURSE_DOCS: 'Search nurse docs',
	SEARCH_ORGANIZATION: 'Search organization',
	SEARCH_REQUIREMENTS: 'Search requirements',
	SEARCH_USERS: 'Search users',
	SELECT_NPS_SCORE: 'Select nps score',
	SEND_NEW_SHIFT_FOR_CONFIRMATION: 'Send new shift for confirmation',
	SHIFT_DETAILS: 'Shift details',
	SHOW_ADD_BREAK_FORM: 'Show add break form',
	SHOW_ADD_USER_FORM: 'Show add user form',
	SHOW_BONUS_FILTER: 'Show Bonus Filter',
	SHOW_CALENDAR: 'Show calendar',
	SHOW_CHECKOUT_PAGE: 'Show checkout page',
	SHOW_EDIT_USER_FORM: 'Show edit user form',
	SHOW_FORGOT_PASSWORD_FORM: 'Show forgot password form',
	SHOW_NEW_DNR_ADD_FORM: 'Show new dnr add form',
	SHOW_NEW_JOB_HISTORY_FORM: 'Show new job history form',
	SHOW_NEW_ORGANIZATION_FORM: 'Show new organization form',
	SHOW_NEW_REQUIREMENT_FORM: 'Show new requirement form',
	SHOW_NEW_SHIFT_FORM: 'Show new shift form',
	SHOW_NURSE_RATING_DIALOG: 'Show nurse rating dialog',
	SHOW_ORGANIZATOIN_DETAIL: 'Show organization detail',
	SHOW_PERSONAL_DETAIL_UPDATE_FROM: 'Show personal detail update form',
	SHOW_SHIFT_CANCEL_DIALOG: 'Show shift cancel dialog',
	SHOW_SHIFT_DETAIL: 'Show shift detail',
	SHOW_SHIFT_EDIT_FORM: 'Show shift edit form',
	SHOW_SHIFTS_FILTER: 'Show shifts filter',
	SHOW_TIMESHEET_DETAIL: 'Show timesheet detail',
	SHOW_USER_DETAIL: 'Show user detail',
	SIGN_IN_COMPLETE: 'Signin complete',
	SIGN_IN_INITIATE: 'Signin initiate',
	SIGN_UP_COMPLETE: 'Sign up complete',
	SIGN_UP_INITIATE: 'Sign up initiate',
	SORT_DNR: 'Sort dnr',
	SORT_ORGANIZATIONS_LIST: 'Sort list',
	SORT_SHIFTS: 'Sort shifts',
	SORT_TIMESHEETS_LIST: 'Sort timesheet list',
	SORT_USERS: 'Sort users',
	START_IMPERSONATING_SUPERVISOR: 'Start Impersonating Supervisor',
	STOP_CONFIRMATION_PAGE: 'Stop confirmation page',
	STOP_IMPERSONATING_SUPERVISOR: 'Stop Impersonating Supervisor',
	SUBMIT_FEEDBACK_FORM: 'Submit feedback form',
	SUBMIT_NPS_SURVEY: 'Submit nps survey',
	SUBMIT_NURSE_RATING: 'Submit nurse rating',
	SUBMIT_ORGANIZATION_RATING: 'Submit organization rating',
	SUPERVISOR_ACKNOWLEDGE_INSTANT_ACCEPTED_SHIFT: 'Supervisor Acknowledge Instant Accepted Shift',
	SUPERVISOR_APPLY_NURSE_DNR: 'Supervisor Apply Nurse Dnr',
	SUPERVISOR_APPLY_NURSE_FILTER: 'Supervisor Apply Nurse Filter',
	SUPERVISOR_CLOSE_SHIFT_REQUEST_MODAL: 'Supervisor Close Shift Request Modal',
	SUPERVISOR_CONFIRM_NURSE_DNR: 'Supervisor Confirm Nurse Dnr',
	SUPERVISOR_DASHBOARD_CHANGE_SHIFT_OPEN_POSITIONS: 'Supervisor Dashboard Change Shift Open Position Count',
	SUPERVISOR_DASHBOARD_SEARCH_SHIFT: 'Supervisor dashboard search shift',
	SUPERVISOR_DASHBOARD_SET_DATE: 'Supervisor dashboard set date',
	SUPERVISOR_DASHBOARD_SET_TODAY: 'Supervisor dashboard set today',
	SUPERVISOR_INSTANT_ACCEPT_CANCEL: 'Supervisor Instant Accept Shift Cancel',
	SUPERVISOR_INSTANT_ACCEPT_TOGGLE: 'Supervisor Instant Accept Shift Toggle',
	SUPERVISOR_OPEN_NURSE_MESSAGE_PANEL: 'Supervisor Open Nurse Messaging Panel',
	SUPERVISOR_OPEN_NURSE_REQUEST: 'Supervisor Open Nurse Request',
	SUPERVISOR_REMOVE_NURSE_DNR: 'Supervisor Remove Nurse Dnr',
	SUPERVISOR_SENT_MESSAGE_NURSE_MESSAGE_PANEL: 'Supervisor Sent Message To Nurse From Nurse List Page',
	SUPERVISOR_SENT_NURSE_REQUEST: 'Supervisor Sent Nurse Request',
	SUPERVISOR_SHOW_NURSE_FILTER: 'Supervisor Show Nurse Filter',
	SUPERVISOR_VIEW_HELP_PAGE: 'Supervisor View Help Page',
	SUPERVISOR_VIEW_NURSE_PAGE: 'SuperVisor View Nurse Page',
	SUPERVISOR_WITHDRAW_NURSE_REQUEST: 'Supervisor Withdraw Nurse Request',
	SUSPEND_NURSE: 'Suspend nurse',
	TIMESHEET_DETAIL_NAVIGATE_BACK: 'Timesheet detail navigate back',
	TOGGLE_NPS_SURVEY: 'Toggle nps survey',
	UNDO_REJECT_NURSE_APPLIED_SHIFT: 'Undo decline nurse for shift',
	UNREGISTER_NURSE: 'Unregister nurse',
	UNSUSPEND_NURSE: 'Unsuspend nurse',
	UPDATE_FEATURE: 'Update feature',
	UPDATE_JOB_PROFILE: 'Update job profile',
	UPDATE_PERSONAL_DETAILS: 'Edit personal detials',
	UPDATE_REQUIREMENT: 'Update requirement',
	UPDATE_SHIFT: 'Update shift',
	UPDATE_TIMESHEET_STATUS: 'Update timesheet status',
	UPDATE_USER: 'Udpate user',
	UPLOAD_IMAGE_IN_FACILITY_DETAILS: 'Upload image in facility details',
	UPLOAD_RESUME: 'Upload resume',
	USER_DETAILS_NAVIGATE_BACK: 'User details navigate back',
	VERIFY_RESET_TOKEN: 'Verify reset token',
	VIEW_ACCOUNT_DETAILS: 'View account details',
	VIEW_ALERTS: 'View alerts',
	VIEW_BONUS_DETAILS: 'View Bonus Details',
	VIEW_CREDENTIALS: 'View Credentials',
	VIEW_FACILITY_DETAILS_EDIT_TAB: 'View facility details edit tab',
	VIEW_FEATURE_SETTINGS: 'View feature settings',
	VIEW_JOB_HISTORY: 'View job history',
	VIEW_NOTIFICATION: 'View notification',
	VIEW_NPS_SURVEY: 'View nps survey',
	VIEW_ORGANIZATION_TAB: 'View organization tab',
	VIEW_PERSONAL_DETAILS: 'View personal details',
	VIEW_REQUIRED_DOCS: 'View required docs',
	VIEW_REQUIREMENT_DETAIL: 'View requirement detail',
	VIEW_REWARD_HISTORY: 'View reward history',
	VIEW_SHIFT_HISTORY: 'View shift history',
	VIEW_SHIFTS: 'View shifts',
	VIEW_SUPERVISOR_DASHBOARD: 'View supervisor dashboard',
	VIEWED_ADMIN_DASHBOARD: 'Viewed admin dashboard',
	VIEWED_NURSE_DASHBOARD: 'Viewed nurse dashboard',
	WITHDRAW_SHIFT: 'Withdraw shift',
	YES_CONFIRMATION_PAGE: 'Yes confirmation page'
};
